import { AppPageComponent } from '../../shared/ui';
import { TopLevelComponent } from '../../shared/models/';
import { Observable, Subscription } from 'rxjs';
import { Store, StoreHelper, UserService } from '../../shared/services';
import { ChatService } from '../chat.service';
import { User } from '../../shared/models';
import { ChatMessage, Thread } from '../models';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'chat-box',
    template: require('./chat-box.component.pug'),
    styles: [require('./chat-box.component.scss')]
})
export class ChatBoxComponent extends TopLevelComponent implements OnInit, OnDestroy {
    @ViewChild(AppPageComponent) appPage;

    // Subscriptions
    private getMessageSub: Subscription;

    fg: FormGroup = new FormGroup({});

    user: User;
    currentThread: Thread;
    messages$: Observable<ChatMessage[]>;

    constructor(private chatService: ChatService,
                userService: UserService,
                store: Store,
                storeHelper: StoreHelper,
                ) {
         super(store, storeHelper, userService);
         this.user = this.chatService.user;
         this.currentThread = this.chatService.thread;
         this.messages$ = this.chatService.messages$;
    }

    ngOnInit() {
         this.headerTitle = `MESSAGES - ${this.currentThread.region.name}`;
         this.headerActions = [ { id: 'none', icon: 'none' } ];
         this.getMessageSub = this.chatService.getMessageHistory()
         .subscribe(() => this.appPage.deactivatePreloader());
    }

    onEnter(event: any): void {
        this.sendMessage(event);
    }

    sendMessage(event: any): void {
        event.preventDefault();
        if (this.fg.pristine) { return; }
        this.chatService.sendChatMessageToSignalR(this.fg.value.message);
        this.fg.reset();
        if (this.currentThread.region.id === -1) {
            this.getMessageSub.unsubscribe();
            this.getMessageSub = this.chatService.getMessageHistory().subscribe();
        }
   }

    ngOnDestroy() {
        this.getMessageSub.unsubscribe();
        this.messages$ = null;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/chat-box/chat-box.component.ts